
const ParseJSONorString = (value) => {
    try {
        const parsedValue = JSON.parse(value);
        return parsedValue;
    } catch (error) {
        return value;
    }
}

export default ParseJSONorString;